module.exports = __webpack_public_path__ + "img/404.219ba887.png";